"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCurrency = formatCurrency;
exports.formatNumber = formatNumber;
function formatNumber(value, decimalPlaces = 0, locale = 'en-US') {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: decimalPlaces
  }).format(value);
}
function formatCurrency(value, currency = 'USD', decimalPlaces = 0, locale = 'en-US') {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: decimalPlaces
  }).format(value);
}
//# sourceMappingURL=number.js.map